module.exports = __webpack_public_path__ + "img/logoSite.e52445ea.svg";